export const HOME_PAGE = '/'
export const ABOUT_ME_PAGE = '/about-me'
export const GALLERY_PAGE = '/gallery'
export const GALLERY_DRAWINGS_PAGE = '/archive/drawings'
export const GALLERY_PAINTINGS_PAGE = '/archive/paintings'
// export const GALLERY_SCULPTURE_PAGE = '/gallery/sculpture'
export const CONTACT_PAGE = '/contact'
export const ADMIN_PANEL_PAGE = '/admin'
